export const NeedToKnowComponent = {
  bindings: {
    venue: '<',
  },
  template: require('./need-to-know.component.jade'),
};
